import { FC } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "src/store/hooks";
import {
  closeToaster,
  triggerViewSummary,
  abortUpload,
  openDetailsModal,
} from "src/store/slices/upload-progress.slice";
import UploadProgressToaster from "./upload-progress-toaster.component";
import AssetUploadDetailsModal from "./asset-upload-details-modal.component";

const GlobalUploadToaster: FC = () => {
  const dispatch = useAppDispatch();

  const { phase, fileName, progress, summary, errorModalOpen, detailsModalOpen } =
    useSelector((state: any) => state.uploadProgress);

  const isModalOpen = errorModalOpen || detailsModalOpen;

  const handleViewSummary = () => {
    dispatch(triggerViewSummary());
  };

  const handleClose = () => {
    const isInProgress = phase === "uploading" || phase === "processing";
    if (isInProgress) {
      dispatch(abortUpload());
    }

    dispatch(closeToaster());
  };

  return (
    <>
      {/* Hidden (not unmounted) while a modal is open so the toaster's
          auto-view-summary state isn't reset and re-triggered on remount */}
      <div style={{ display: isModalOpen ? "none" : undefined }}>
        <UploadProgressToaster
          phase={phase}
          fileName={fileName}
          progress={progress}
          summary={summary}
          onViewSummary={handleViewSummary}
          onClose={handleClose}
          onSeeDetails={() => dispatch(openDetailsModal())}
        />
      </div>
      <AssetUploadDetailsModal />
    </>
  );
};

export default GlobalUploadToaster;